import { EProjects } from 'src/app/shared/enums/projects.enum';
import * as get from 'lodash.get';
import { ERoutes } from 'src/app/checkin-app/modules/checkin/pages/guests/enums/routes.enum';
function messagesHandler(send, res) {
    var _this = this;
    this.config.inbox.messages.load(res.messages, function (unread) {
        var _a;
        var project = _this.config[_this.config.project];
        var isInboxProject = _this.config.project === EProjects.INBOX;
        var path = get(_this.activatedRoute, 'firstChild.firstChild.firstChild.routeConfig.path', '');
        var isInboxPath = (_a = {},
            _a[ERoutes.INBOX] = true,
            _a[ERoutes.COMMENTS] = true,
            _a)[path];
        project.setNotification([ERoutes.INBOX, ERoutes.COMMENTS], ((isInboxProject || isInboxPath) ? 0 : unread));
    });
}
export default messagesHandler;
